type ServerConsentRequiredReader = () => boolean | undefined

let readServerConsentRequired: ServerConsentRequiredReader | undefined

/** Server render registers this so SSR and hydration see the same rollout value. */
export function registerServerConsentRequiredReader(reader: ServerConsentRequiredReader) {
  readServerConsentRequired = reader
}

export function isConsentRequired(browserRequired: boolean | undefined): boolean {
  if (browserRequired !== undefined) return browserRequired
  return readServerConsentRequired?.() === true
}

export function isConsentRequiredOnClient(): boolean {
  const browserRequired = typeof window === 'undefined'
    ? undefined
    : (window as any).__CONSENT_REQUIRED__ === true
  return isConsentRequired(browserRequired)
}
